import React, { useContext, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { EffectFade, Navigation, Autoplay, Scrollbar } from "swiper/modules";
import { NavLink, useNavigate } from "react-router-dom";
import { LanguageContext } from "../../context/LanguageContext";
import translations from "../../data/langData";
import { ApiLinkContext } from "../../context/ApiLinkContext";
import axios from "axios";

import first from "../../assets/img/slider1.png";
import second from "../../assets/img/slider2.jpeg";
import three from "../../assets/img/slider3.jpeg";
import slider4 from "../../assets/img/slider4.jpg";

const HomeSlider = () => {
  const { products, brand, tag, accord } = useContext(ApiLinkContext);
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  const [query, setQuery] = useState("");
  const navigate = useNavigate();
  const handleSubmit = (e) => {
    e.preventDefault();
    const result = products.filter((item) =>
      item.name.toLowerCase().includes(query.toLowerCase())
    );
    const brandResult = brand.filter((item) =>
      item.bName.toLowerCase().includes(query.toLowerCase())
    );

    const accordResult = accord.filter((item) =>
      item.aName.toLowerCase().includes(query.toLowerCase())
    );

    const tagResult = tag.filter((item) =>
      item.tName.toLowerCase().includes(query.toLowerCase())
    );

    const data =
      result.length > 0
        ? { type: "product", items: result }
        : brandResult.length > 0
        ? { type: "brand", items: brandResult }
        : accordResult.length > 0
        ? { type: "accord", items: accordResult }
        : tagResult.length > 0
        ? { type: "tag", items: tagResult }
        : null;
    navigate("/perfume", {
      state: { data, query },
    });
  };

  return (
    <>
      <Swiper
        spaceBetween={30}
        effect={"fade"}
        navigation={true}
        scrollbar={{ hide: false }}
        modules={[EffectFade, Navigation, Scrollbar]}
        className="mySwiper mySwiperHome"
      >
        {/* <SwiperSlide>
          <NavLink to="/14-joy">
            <div className="slider_container">
              <img
                src={first}
                className="img-fluid homeBanner  w-100"
                style={{ height: "500px", objectFit: "cover" }}
              />
   <div
                className="sliderTextPosition animate__animated animate__fadeInRight"
                style={{
                  top: "25%",
                  left: "60%",
                  transform: `translate(${
                    language === "az"
                      ? "-7%"
                      : language === "en"
                      ? "-2%"
                      : "-3%"
                  }, -25%)`,
                  position: "absolute",
                  textShadow: "2px 2px 5px rgba(0, 0, 0, 0.3)",
                }}
              >
                <h1 className="text-center text-uppercase">Xerjoff</h1>
                <p className="text-center text-uppercase">Erba Pura</p>
              </div>
            </div>
          </NavLink>
        </SwiperSlide> */}
        <SwiperSlide>
          <NavLink to="/163-invictus-parfum">
            <div className="slider_container">
              <img src={second} className="img-fluid homeBanner w-100"  />
              <div
                className="sliderTextPosition animate__animated animate__fadeInRight"
                style={{
                  top: "25%",
                  left: "40%",
                  transform: `translate(${
                    language === "az"
                      ? "-7%"
                      : language === "en"
                      ? "-2%"
                      : "-3%"
                  }, -25%)`,
                  position: "absolute",
                  textShadow: "2px 2px 5px rgba(0, 0, 0, 0.3)",
                }}
              >
                <h1 className="text-center text-uppercase">Paco Rabanne</h1>
                <p className="text-center text-uppercase">Invictus Parfum</p>
              </div>
              {/* <div className="outline"></div> */}
            </div>
          </NavLink>
        </SwiperSlide>
        <SwiperSlide>
          <NavLink to="/67-hindu-kush">
            <div className="slider_container">
              <img src={three} className="img-fluid homeBanner  w-100"  />
              <div
                className="sliderTextPosition animate__animated animate__fadeInRight"
                style={{
                  top: "22%",
                  left: "10%",
                  transform: `translate(${
                    language === "az"
                      ? "-7%"
                      : language === "en"
                      ? "-2%"
                      : "-3%"
                  }, -25%)`,
                  position: "absolute",
                  textShadow: "2px 2px 5px rgba(0, 0, 0, 0.3)",
                }}
              >
                <h1 className="text-center text-uppercase">Mancera</h1>
                <p className="text-uppercase text-center">Hindu Kush</p>
              </div>
              {/* <div className="outline"></div> */}
            </div>
          </NavLink>
        </SwiperSlide>
        <SwiperSlide>
          <NavLink to="/74-1-million-royal">
            <div className="slider_container">
              <img src={slider4} className="img-fluid homeBanner  w-100"   />
              <div
                className="sliderTextPosition animate__animated animate__fadeInRight"
                style={{
                  top: "22%",
                  right: "10%",
                  transform: `translate(${
                    language === "az"
                      ? "-7%"
                      : language === "en"
                      ? "-2%"
                      : "-3%"
                  }, -25%)`,
                  position: "absolute",
                  textShadow: "2px 2px 5px rgba(0, 0, 0, 0.3)",
                }}
              >
                <h1 className="text-center text-uppercase">Paco Rabanne </h1>
                <p className="text-uppercase text-center">1 Million Royal</p>
              </div>
              <div className="outline"></div>
            </div>
          </NavLink>
        </SwiperSlide>
      </Swiper>
    </>
  );
};

export default HomeSlider;
